import React, { Fragment, Component } from 'react'
import "./social.css";
import Feed from "./shared/feed/Feed";
import { getProfileImage, getSmallImage, getName }  from "./shared/utils"

export class List extends Component { 

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const currentUser = this.props.user;
    if (currentUser.type.includes('corporate') || currentUser.type.includes('brand')) {
       this.props.fetchBrand();
    }
  }

  

  render() {

    const currentUser = this.props.user;

    return (
      <Fragment>
        <div className="profile">
          <div className="profileRight">
            <div className="profileRightTop">
              <div className="profileCover">
                { currentUser && 
                   getProfileImage(currentUser)
                }
                {
                  currentUser && getSmallImage(currentUser, this.props.brand)
                }
              </div>
              <div className="profileInfo">
                  <h4 className="profileInfoName">{
                  currentUser && getName(currentUser)
                }</h4>
              </div>
            </div>
            <div className="profileRightBottom">
              <Feed  {...this.props} />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/social/index.jsx